import React, { Component, componentDidMount } from 'react';
import CustomButton from './CustomButton';
import './style.css';
import Aos from 'aos';
import "aos/dist/aos.css";

class InfoBox extends Component {
    
    componentDidMount() {
        Aos.init({ duration: 700,
            delay:200});
      }
  
    

    render(){
        return (
            <div className="info-box" data-aos="fade-up" id={this.props.variant}>
                <div className={this.props.className}>
                    <div className="info-box-img">
                        <img src={this.props.img}/>
                    </div>
                    <div className="info-box-text">
                        <h3>{this.props.title}</h3> 
                        <p>{this.props.text}</p>

                        { 
                        
                        this.props.button  ?
                            <a href={this.props.link}>
                                <CustomButton text="FIND OUT MORE → " style={{backgroundColor:'#008cff'}} id="btn"/>
                            </a>
                            :
                            <></>
                        }
                       
                    </div>
                </div>
            </div>
        )
    }
}

export default InfoBox;
